import { css } from 'fe-styled-components';

/**
 * Box Sizing
 */
const boxSizingBase = css`
  &,
  &::before,
  &::after {
    box-sizing: border-box;
  }
`;

const boxSizingChildren = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

/**
 * Returns box-sizing (border-box) css
 * @param {boolean} children
 * @return {object} styled-components css
 */
const boxSizing = (children = false) =>
  typeof children === 'boolean' && children
    ? css`
        ${boxSizingBase}
        ${boxSizingChildren}
      `
    : boxSizingBase;

/**
 * List Reset
 */
const resetList = css`
  margin: 0;
  padding: 0;
  list-style: none;
`;

/**
 * List Button
 */
const resetButton = css`
  border: 0;
  outline: 0;
  cursor: pointer;
  font: inherit;
  touch-action: manipulation;
  width: auto;
  background-color: transparent;
  user-select: none;
`;

export { boxSizing, resetList, resetButton };
